import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { Constant } from "../../constant";
import { ShortcutService } from "../../service/shortcut.service";
import { of } from 'rxjs';
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'warning-popup',
    templateUrl: "./warning-popup.html",
    styleUrls: ["./warning-popup.scss"]
})

export class WarningPopupComponent implements OnInit {
    public Constant = Constant;
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() message: any;
    @Input() title: any;
    @Input() isOkButton: any;
    @Input() iconImage: any = Constant.icon_url_warning;
    @Input() isDismissAll: boolean;
    constructor(
        public eventManger: EventManagerService,
        public activeModal: NgbActiveModal,
        public ngModal: NgbModal
    ) {}
    ngOnInit() {
    }
    dismiss() {
        if (!this.isDismissAll) {
            this.activeModal.dismiss();
        } else {
            this.ngModal.dismissAll();
        }
        this.result.emit(true);
    }
}
